import React from 'react';
import { useNotifications } from '../context/NotificationContext';
import { X, Trash2, CheckCheck } from 'lucide-react';
import './NotificationCenter.css';

const NotificationCenter = ({ isOpen, onClose }) => {
  const { notifications, markAsRead, clearNotifications } = useNotifications();

  if (!isOpen) return null;

  return (
    <div className="notification-center-dropdown">
      <div className="nc-header">
        <h3>Notificaciones</h3>
        <div className="nc-actions">
          <button onClick={markAsRead} title="Marcar todo como leído">
            <CheckCheck size={16} />
          </button>
          <button onClick={clearNotifications} title="Limpiar todo">
            <Trash2 size={16} />
          </button>
          <button onClick={onClose} className="nc-close">
            <X size={18} />
          </button>
        </div>
      </div>
      
      <div className="nc-body">
        {notifications.length === 0 ? (
          <div className="nc-empty">No hay notificaciones nuevas</div>
        ) : (
          notifications.map(n => (
            <div key={n.id} className={`nc-item ${n.read ? 'read' : 'unread'} ${n.type}`}>
              <div className="nc-item-content">
                <p className="nc-message">{n.message}</p>
                <span className="nc-time">{n.time}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationCenter;
